import React from 'react';
import Styled from 'styled-components';

const Container = Styled.div`
    border:1px solid #ddd;
    display:inline-block;
    padding:6px;
    cursor: pointer;
    margin:6px;
    &:hover{

    }
`;

const CellButtonsContainer = Styled.div`
display:flex;
margin-top:-30px;
width:100%;
justify-content:flex-end;
`;

export const CellButton = function(props) {
  return <Container className={props.className} onClick={props.onClick}>{props.children}</Container>;
};

export const CellButtons = function(props) {
  if (!props.children) return null;
  return <CellButtonsContainer>{props.children}</CellButtonsContainer>;
};
